import { Progress } from 'reactstrap';
import { useAppSelector } from 'hooks/hooks';


const Loading = () => {
    const customer = useAppSelector(x => x.customers.selectedCustomer);
    const isLoading = useAppSelector(x => x.invoices.loading || x.orders.loading || x.cases.loading || x.returns.loading || x.creditMemos.loading);

    const barColor = customer?.primaryColor || "var(--bcd-green-hex)";

    return (
        <>
            {isLoading &&
                <div className="w-50 mt-4 text-center">
                    <Progress
                        animated
                        style={{ height: "5px" }}
                        className="mt-2 mb-0 mx-auto w-25"
                        value={100}
                        barStyle={{ backgroundColor: barColor }}
                    />
                </div>}
        </>
    );
}

export default Loading;